import { Stack, Typography, styled } from '@mui/material';
import { TabsCustom } from 'app/components/elements/TabsCutom';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { headerTabIssues, TAB_ISSUES } from './const';
import { IssuesRoomTab } from './components/IssuesRoomTab';
import { IssuesAssetTab } from './components/IssuesAssetTab';
import { IssuesAdHocTab } from './components/IssuesAdHocTab';
import { IssuesAssignmentsTab } from './components/IssuesAssignmentsTab';

export const IssuesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onChangeTab = useCallback(
    (tabIndex: number) => {
      const nameTab = headerTabIssues.find((item) => item.value === tabIndex)?.param;
      setSearchParams({ tab: nameTab || TAB_ISSUES.ROOM_ISSUES });
    },
    [setSearchParams]
  );

  const currentTabParam = (searchParams.get('tab') as string) || TAB_ISSUES.ROOM_ISSUES;
  const adHocIssueIdParam = searchParams.get('adHocIssueId');
  const adHocIssueId = adHocIssueIdParam ? Number(adHocIssueIdParam) : undefined;
  const tab =
    headerTabIssues.find((item) => item.param === currentTabParam)?.value ??
    headerTabIssues[0].value;

  const renderTab = () => {
    switch (currentTabParam) {
      case TAB_ISSUES.ASSET_ISSUES:
        return <IssuesAssetTab />;
      case TAB_ISSUES.AD_HOC_ISSUES:
        return <IssuesAdHocTab initialIssueId={adHocIssueId} />;
      case TAB_ISSUES.ASSIGNMENTS:
        return <IssuesAssignmentsTab />;
      case TAB_ISSUES.ROOM_ISSUES:
      default:
        return <IssuesRoomTab />;
    }
  };

  return (
    <WrapperPage>
      <TitleStyled>Issues</TitleStyled>
      <TabsCustom
        tab={tab}
        contentTab={renderTab()}
        headerTab={headerTabIssues}
        onChangeTab={onChangeTab}
      />
    </WrapperPage>
  );
};

const WrapperPage = styled(Stack)(() => ({
  padding: '54px 40px',
  width: '100%',
  minHeight: '100vh',
  gap: 20
}));

const TitleStyled = styled(Typography)(() => ({
  color: '#226AAA',
  fontSize: '24px',
  fontWeight: 900
}));
